import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-missing-date-adoption",
  // imports: [],
  templateUrl: "./missing-date-adoption.component.html",
  styleUrl: "./missing-date-adoption.component.css",
  standalone: false,
})
export class MissingDateAdoptionComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
